import React, { useState, useEffect } from 'react';
import Header from '../Header';
import { Form, Button, Alert, Card } from 'react-bootstrap'; // Import components from react-bootstrap

const EmpRaiseTicket = () => {
  const [Users, setUsers] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const [error, setError] = useState(null);

  const id = localStorage.getItem('userId'); // Get the userId from localStorage

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch('https://apiaksharaconnect.aksharafinalytics.in/users');
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const result = await response.json();
        setUsers(result.user || []); 
      } catch (error) {
        setError(error.message);
      }
    };

    fetchData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true); 

    const form = e.target;
    const formData = new FormData(form);

    formData.append('emp_id', id);

    try {
      const response = await fetch('https://apiaksharaconnect.aksharafinalytics.in/EmpRaiseTicket', {
        method: 'POST',
        body: formData,
      });

      console.log(formData);

      if (response.ok) {
        setSuccessMessage('Ticket raised successfully!');
        form.reset(); 
      } else {
        const errorData = await response.json();
        alert(`Failed to submit the ticket: ${errorData.message || 'Unknown error'}`);
      }
    } catch (error) {
      console.error('Error submitting the ticket:', error);
      setError(error.message);
      setSuccessMessage(null);
    } finally {
      setIsSubmitting(false); 
    }
  };

  return (
    <>
      <Header />
      <div className="container mt-5">
      {error && <Alert variant="danger">{error}</Alert>}
      {successMessage && <Alert variant="success">{successMessage}</Alert>}
        <Card className="shadow">
          <Card.Header>
            <h2>Raise Ticket</h2>
          </Card.Header>
          
          <Card.Body>
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <input type="hidden" id="emp_id" name="emp_id" className="form-control" value={id} readOnly />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Users</Form.Label>
                <Form.Control as="select" name="user_id">
                  <option value="">-- select user --</option>
                  {Users.map((user) => (
                    <option key={user.id} value={user.id}>
                      {user.company}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label htmlFor="subject">Subject</Form.Label>
                <Form.Control type="text"  id="subject" name="subject" required />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label htmlFor="description">Description</Form.Label>
                <Form.Control as="textarea" id="description"  name="description" rows="4" required />
              </Form.Group>

              <Form.Group className="mb-3 d-none">
                <Form.Label htmlFor="attachment">Attachment</Form.Label>
                <Form.Control type="file"id="file" name="file"/>
              </Form.Group>

              <div className="text-center">
                <Button type="submit" variant="primary" disabled={isSubmitting} >
                  {isSubmitting ? 'Submitting...' : 'Submit'}
                </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </div>
    </>
  );
};

export default EmpRaiseTicket;
